import { store } from "../../redux/store";
import type { RootState } from "../../redux/store";

type MonthFormat = "short" | "long";

const getActiveTimeZone = (timeZoneSetting: string): string => {
  if (timeZoneSetting === "Set Automatically") {
    const detectedTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return detectedTimeZone;
  }

  return timeZoneSetting;
};

export const gxDateTimeFormat = (
  dateString?: string | null,
  monthFormat: MonthFormat = "short",
): string => {
  if (!dateString) {
    return "";
  }

  const parsed = new Date(dateString);
  if (isNaN(parsed.getTime())) {
    return "";
  }

  // Get timezone from Redux store
  const state = store.getState() as RootState;
  const timeZoneSetting = state.settings.timeZone;

  const activeTimeZone = getActiveTimeZone(timeZoneSetting);

  let formatted = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: monthFormat,
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: activeTimeZone,
  })
    .format(parsed)
    .replace(",", "");
  formatted = formatted.replace(
    /\b([a-z]+)\b/i,
    (match) => match.charAt(0).toUpperCase() + match.slice(1).toLowerCase(),
  );

  formatted = formatted.replace(/\b(am|pm)\b/gi, (m) => m.toUpperCase());

  return formatted;
};

export const gxDateFormat = (
  dateString?: string | null,
  monthFormat: "short" | "long" = "short",
): string => {
  if (!dateString) {
    return "";
  }

  const parsed = new Date(dateString);
  if (isNaN(parsed.getTime())) {
    return "";
  }

  // Get timezone from Redux store
  const state = store.getState() as RootState;
  const timeZoneSetting = state.settings.timeZone;
  const activeTimeZone = getActiveTimeZone(timeZoneSetting);

  // Format only date (DD-MMM-YYYY)
  let formatted = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: monthFormat,
    year: "numeric",
    timeZone: activeTimeZone,
  }).format(parsed);

  // Capitalize month abbreviation (e.g., May)
  formatted = formatted.replace(
    /\b([a-z]+)\b/i,
    (match) => match.charAt(0).toUpperCase() + match.slice(1).toLowerCase(),
  );

  return formatted;
};


export const gxDateTimeFormatLong = (dateString?: string | null): string => {
  if (!dateString) {
    return "";
  }

  const parsed = new Date(dateString);
  if (isNaN(parsed.getTime())) {
    return "";
  }

  const state = store.getState() as RootState;
  const timeZoneSetting = state.settings.timeZone;

  const activeTimeZone = getActiveTimeZone(timeZoneSetting);

  let formatted = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: activeTimeZone,
  })
    .format(parsed)
    .replace(",", "");

  formatted = formatted.replace(
    /\b([A-Z]{3,}|[a-z]{3,})\b/g,
    (match) => match.charAt(0).toUpperCase() + match.slice(1).toLowerCase(),
  );

  formatted = formatted.replace(/\b(am|pm)\b/gi, (m) => m.toUpperCase());

  return formatted;
};
